module.exports = __webpack_public_path__ + "images/img_3_2-b1a789e392.png";